// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__ReaA4","label":"Completed_label__3_AUC"};